import React, { useState, useEffect } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import SearchIcon from "../../assets/images/icons/search-icon.webp";
import { BiSearch } from "react-icons/bi";
import { casinoSection } from "../../lib/data/casinoSection.data";
import { auraGames } from "../../lib/data/auraGames.data";
import { SlotGames } from "../../lib/data/SlotGames.data";
import { KingmakerGames } from "../../lib/data/KingmakerGames.data";
import { QtechGames } from "../../lib/data/QtechGames.data";
import { casinoPageData } from "../../lib/data/casinoTabs.data";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);

  const totalGames = {
    ...casinoSection?.popularGames,
    ...casinoSection?.AndarBahar,
    ...casinoSection?.roulettetab,
    ...casinoSection?.dragontiger,
    ...casinoSection?.baccarattab,
    ...casinoSection?.tvShows,
    ...casinoSection?.blackjacktab,
    ...casinoSection?.pokertab,
    ...casinoSection?.spribe,
    ...casinoSection?.supernowa,
    ...casinoSection?.vivo,
    ...auraGames?.improvedExperience,
    ...auraGames?.cardGames,
    ...auraGames?.virtualCardGames,
    ...auraGames?.instantGames,
    ...SlotGames?.netenttab,
    ...SlotGames?.redtigertab,
    ...KingmakerGames?.kingmaker,
    ...QtechGames?.turbo,
    ...QtechGames?.hacksaw,
    ...casinoPageData?.auragaming?.cardGames,
    ...casinoPageData?.auragaming?.improvedExperience,
    ...casinoPageData?.auragaming?.instantGames,
    ...casinoPageData?.auragaming?.mines,
    ...casinoPageData?.auragaming?.virtualCardGames,
    ...casinoPageData?.crashGames?.crashGames,
    ...casinoPageData?.dragoonSoft?.dragoonSoft,
    ...casinoPageData?.evolution?.baccarat,
    ...casinoPageData?.evolution?.blackjack,
    ...casinoPageData?.evolution?.craps,
    ...casinoPageData?.evolution?.gameshow,
     ...casinoPageData?.evolution?.poker,
      ...casinoPageData?.evolution?.roulette,
       ...casinoPageData?.evolution?.sicbo,
    ...casinoPageData?.ezugi?.andarbahar,
    ...casinoPageData?.ezugi?.baccarat,
    ...casinoPageData?.ezugi?.blackjack,
    ...casinoPageData?.ezugi?.cards32,
    ...casinoPageData?.ezugi?.craps,
    ...casinoPageData?.ezugi?.lottery,
    ...casinoPageData?.ezugi?.lucky7,
    ...casinoPageData?.ezugi?.poker,
    ...casinoPageData?.ezugi?.roulette,
    ...casinoPageData?.ezugi?.sicbo,
    ...casinoPageData?.habanero?.habanero,
    ...casinoPageData?.hacksaw?.hacksaw,
    ...casinoPageData?.hacksaw?.mines,
    ...casinoPageData?.instantWin?.instantWin,
    ...casinoPageData?.jili?.jili,
    ...casinoPageData?.kingmaker?.kingmaker,
    ...casinoPageData?.kingmaker?.mines,
    ...casinoPageData?.lottery?.lottery,
    ...casinoPageData?.mac88?.andarbahar,
    ...casinoPageData?.mac88?.baccarat,
    ...casinoPageData?.mac88?.cards32,
    ...casinoPageData?.mac88?.dragontiger,
    ...casinoPageData?.mac88?.dragontiger,
    ...casinoPageData?.mac88?.hiLo,
    ...casinoPageData?.mac88?.liveGameShows,
    ...casinoPageData?.mac88?.lucky7,
    ...casinoPageData?.mac88?.others,
    ...casinoPageData?.mac88?.poker,
    ...casinoPageData?.mac88?.roulette,
    ...casinoPageData?.mac88?.sicbo,
    ...casinoPageData?.mac88?.teenpatti,
    ...casinoPageData?.mac88VR?.andarbahar,
    ...casinoPageData?.mac88VR?.baccarat,
    ...casinoPageData?.mac88VR?.cards32,
    ...casinoPageData?.mac88VR?.crash,
    ...casinoPageData?.mac88VR?.crashX,
    ...casinoPageData?.mac88VR?.dragontiger,
    ...casinoPageData?.mac88VR?.hiLo,
    ...casinoPageData?.mac88VR?.lucky7,
    ...casinoPageData?.mac88VR?.mines,
    ...casinoPageData?.mac88VR?.others,
    ...casinoPageData?.mac88VR?.poker,
    ...casinoPageData?.mac88VR?.roulette,
    ...casinoPageData?.mac88VR?.teenpatti,
    ...casinoPageData?.netent?.netent,
    ...casinoPageData?.playNGo?.playNGo,
    ...casinoPageData?.powergames?.powergames,
    ...casinoPageData?.redtiger?.mines,
    ...casinoPageData?.redtiger?.redtiger,
    ...casinoPageData?.relaxGaming?.relaxGaming,
    ...casinoPageData?.slots?.slots,
    ...casinoPageData?.smartSoft?.crash,
    ...casinoPageData?.smartSoft?.crashX,
    ...casinoPageData?.smartSoft?.others,
    ...casinoPageData?.spribe?.crash,
    ...casinoPageData?.spribe?.hiLo,
    ...casinoPageData?.spribe?.others,
    ...casinoPageData?.spribe?.roulette,
    ...casinoPageData?.supernowa?.andarbahar,
    ...casinoPageData?.supernowa?.baccarat,
    ...casinoPageData?.supernowa?.cards32,
    ...casinoPageData?.supernowa?.lucky7,
    ...casinoPageData?.supernowa?.others,
    ...casinoPageData?.supernowa?.poker,
    ...casinoPageData?.supernowa?.rngames,
    ...casinoPageData?.supernowa?.roulette,
    ...casinoPageData?.turbo?.crash,
    ...casinoPageData?.turbo?.crashX,
    ...casinoPageData?.turbo?.hiLo,
    ...casinoPageData?.turbo?.mines,
    ...casinoPageData?.turbo?.turbo,
    ...casinoPageData?.vivo?.andarbahar,
    ...casinoPageData?.vivo?.baccarat,
    ...casinoPageData?.vivo?.blackjack,
    ...casinoPageData?.vivo?.dragontiger,
    ...casinoPageData?.vivo?.poker,
    ...casinoPageData?.vivo?.roulette,
    ...casinoPageData?.vivo?.sicbo,
    ...casinoPageData?.xpg?.baccarat,
    ...casinoPageData?.xpg?.blackjack,
    ...casinoPageData?.xpg?.cards32,
    ...casinoPageData?.xpg?.roulette,
    ...casinoPageData?.xpg?.sicbo,
  };

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };
  const handleSearch = (e) => {
    if (e) {
      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return (
          item?.name && item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1
        );
      });
      setFilteredData(filteredValue);
    }
  };

  return (
    <>
      <div className="search-box">
        <div className="searchGames" onClick={handleShow}>
          <img src={SearchIcon} alt="search" />
          {/* <BiSearch /> */}
          <p>Search...</p>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} className="search-modal">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Search Games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search your favourite games here..."
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>

          <ul className="gamelisting">
            {filteredData &&
              filteredData.map((item) => (
                <li>
                  <a href={item.redirectUrl || item.href}>
                    <img src={item.imgUrl} />
                    <div className="providerName">{item.providerName}</div>
                    <div className="GameName">{item.name}</div>
                  </a>
                </li>
              ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
